import { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import Lenis from 'lenis';
import { CartProvider } from '@/contexts/CartContext';
import Layout from '@/components/Layout';
import Home from '@/pages/Home';
import VibrantPenticton from '@/pages/VibrantPenticton';
import TravelStories from '@/pages/TravelStories';
import TravelStoryDetail from '@/pages/TravelStoryDetail';
import WalkingTours from '@/pages/WalkingTours';
import Store from '@/pages/Store';
import About from '@/pages/About';
import Contact from '@/pages/Contact';
import Blog from '@/pages/Blog';
import '@/App.css';

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smooth: true,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  return (
    <CartProvider>
      <div className="App">
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/vibrant-penticton" element={<VibrantPenticton />} />
              <Route path="/travel-stories" element={<TravelStories />} />
              <Route path="/travel-stories/:slug" element={<TravelStoryDetail />} />
              <Route path="/walking-tours" element={<WalkingTours />} />
              <Route path="/store" element={<Store />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/blog" element={<Blog />} />
            </Routes>
          </Layout>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </CartProvider>
  );
}

export default App;
